import React from 'react';

const IndexLink = ({ section, onNavigate }) => {
  return (
    <li>
      <a
        href={`#${section.id}`}
        className="flex items-center text-texto-oscuro font-semibold no-underline gap-3 px-5 py-[15px] bg-fondo-claro hover:bg-blue-50 border-2 border-transparent hover:border-icetex rounded-xl text-[0.95rem] transition-all duration-300 hover:translate-x-1"
        onClick={(e) => {
          e.preventDefault();
          onNavigate(section.id);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-icetex flex-shrink-0"
          style={{ width: '22px', height: '22px' }}
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
        {section.title}
      </a>
    </li>
  );
};

const TermsIndex = ({ onNavigate }) => {
  const sections = [
    { id: 'servicio', title: 'El servicio y la información' },
    { id: 'registro', title: 'Registro' },
    { id: 'modificacion', title: 'Modificación de contenidos' },
    { id: 'privacidad', title: 'Privacidad de la información' },
    { id: 'propiedad', title: 'Propiedad intelectual' },
    { id: 'ley', title: 'Ley aplicable y jurisdicción' },
  ];

  return (
    <div
      className="bg-white rounded-[20px] p-[35px] mb-[40px]"
      style={{ boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)' }}
    >
      <h3 className="text-texto-oscuro font-bold flex items-center gap-[10px] text-[1.5rem] mb-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-icetex flex-shrink-0"
          style={{ width: '28px', height: '28px' }}
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
        </svg>
        Índice de Contenidos
      </h3>
      <ul
        className="list-none p-0 m-0 grid"
        style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '15px',
        }}
      >
        {sections.map((section) => (
          <IndexLink key={section.id} section={section} onNavigate={onNavigate} />
        ))}
      </ul>
    </div>
  );
};

export default TermsIndex;
